import { trackSnowplow, TrackingType } from './snowplow'
import { getCookie } from 'utils/cookie'
import DeviceId from 'utils/detectDevice'
import { validateSession } from 'components/SetExperiment'
import { domainName, domainType } from 'utils/parseDomain'

export { TrackingType }

interface TrackingEventPayload {
  form_name: string
  event_name: string
  field_name: string
  field_value: string
}

interface TrackingOptions {
  type?: TrackingType
  schema: string
  payload: TrackingEventPayload
}

export async function trackEvent({
  type = TrackingType.REALTIME,
  schema,
  payload,
}: TrackingOptions) {
  validateSession()

  const trackingPayload = {
    ptnr: getCookie('affiliate'),
    platform: DeviceId.isMobile() ? 'wap' : 'web',
    session_id: getCookie('reg_ust'),
    bucket: getCookie('GsuExp') || 'NA',
    form_name: payload.form_name,
    domain: domainName,
    event_name: payload.event_name,
    field_name: payload.field_name,
    field_value: payload.field_value,
    domain_type: domainType,
  }

  trackSnowplow({
    schema,
    trackingType: type,
    data: trackingPayload,
    schemaVersion: '2-0-0',
  })
}
